
document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".wt-page-nav-mega__item--mega").forEach(parentItem => {
    const links   = parentItem.querySelectorAll(".wt-page-nav-mega__sublist__link");
    const panels  = parentItem.querySelectorAll(".wt-page-nav-mega__sublist--content ul");

    links.forEach(link => {
      link.addEventListener("click", e => {
        //e.preventDefault();
        const targetId = link.getAttribute("data-tab");
        const targetPanel = parentItem.querySelector(`#${targetId}`);

        // toggle off if already active
        if (link.classList.contains("active")) {
          link.classList.remove("active");
          if (targetPanel) targetPanel.classList.remove("active");
          return;
        }

        // reset first
        links.forEach(l => l.classList.remove("active"));
        panels.forEach(p => p.classList.remove("active"));

        // activate clicked
        link.classList.add("active");
        if (targetPanel) targetPanel.classList.add("active");
      });
    });

    // 🟢 reset all when mouse leaves the parent mega menu
    parentItem.addEventListener("mouseleave", () => {
      links.forEach(l => l.classList.remove("active"));
      panels.forEach(p => p.classList.remove("active"));
    });
  });


  document.getElementById("wt-drawer-nav").addEventListener("click", function(e) {
    let target = e.target.closest("li, .wt-drawer__close");
    if (!target || !this.contains(target) && !target.classList.contains("wt-drawer__close")) return;
    if (target.classList.contains("wt-drawer__close")) {
      document.querySelectorAll("#wt-drawer-nav .drawer-menu-item-mobile")
        .forEach(el => el.classList.remove("drawer-menu-item-mobile"));
      return;
    }
    if (target.classList.contains("wt-page-nav-mega__item--parent")) {
      target.classList.toggle("drawer-menu-item-mobile");

      if (!target.classList.contains("drawer-menu-item-mobile")) {
        target.querySelectorAll(".wt-page-nav-mega__sublist__item--child")
          .forEach(child => child.classList.remove("drawer-menu-item-mobile"));
      }
    } else if (target.classList.contains("wt-page-nav-mega__sublist__item--child")) {
      target.classList.toggle("drawer-menu-item-mobile");
    }
  });
});
